import { siteAssetPaths } from "@/lib/assets";
import type { SchoolId } from "@/types/navigation";

type SchoolLogoHeroProps = {
  schoolId: SchoolId;
  alt: string;
};

/** NTU 深蓝横幅 cover；其余校徽为 1024×498 白底横幅（留白已烘焙进 PNG）cover 铺满 */
const SCHOOL_LOGO_STYLE: Record<
  SchoolId,
  { container: string; img: string }
> = {
  ntu: {
    container: "relative h-[168px] overflow-hidden bg-[#0a1652]",
    img: "h-full w-full object-cover object-center",
  },
  nus: {
    container: "relative h-[168px] overflow-hidden bg-white",
    img: "h-full w-full object-cover object-center",
  },
  smu: {
    container: "relative h-[168px] overflow-hidden bg-white",
    img: "h-full w-full object-cover object-center",
  },
  jcu: {
    container:
      "relative flex h-[168px] items-center justify-center overflow-hidden bg-white px-10 py-5",
    img: "max-h-[72%] max-w-[88%] object-contain object-center",
  },
  curtin: {
    container: "relative h-[168px] overflow-hidden bg-white",
    img: "h-full w-full object-cover object-center",
  },
};

export function SchoolLogoHero({ schoolId, alt }: SchoolLogoHeroProps) {
  const src = siteAssetPaths.schoolLogo(schoolId);
  const style = SCHOOL_LOGO_STYLE[schoolId];

  return (
    <div className={style.container}>
      <img src={src} alt={alt} className={style.img} />
    </div>
  );
}
